import $http from "./http.service";

const basePath = "/profile";

const create = payload =>
  $http
    .post(basePath, payload)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export default { create };
